import { Box, IconButton, Link } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import { useCopy } from 'src/hooks'

import { getPolygonscanAddressUrl, shortenStringMiddle2 } from 'src/common/utils'
import { useStyles } from './styles'
import { LinkIcon } from 'src/assets/icons'

interface Props {
  address: string
  maxWidth: number | null
}

export const UserAddress = ({ address, maxWidth }: Props) => {
  const classes = useStyles()
  const handleCopy = useCopy(address)

  const lastFour = address.slice(-4)
  const addressWithoutLastFour = address.slice(0, -4)

  return (
    <Box
      className={classes.addressWrapper}
      sx={{ maxWidth: !!maxWidth ? `${maxWidth}px` : '200px' }}
    >
      <Box
        sx={{
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'flex',
          p: 0,
          m: 0,
        }}
      >
        <span
          className={classes.addressText}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {addressWithoutLastFour}
        </span>
        <span className={classes.addressText} style={{ marginLeft: '-1px' }}>
          {lastFour}
        </span>
      </Box>
      {/* <p className={classes.addressText}>{shortenStringMiddle2(address, 19)}</p> */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton size="small" onClick={handleCopy}>
          <ContentCopyIcon className={classes.copyIcon} />
        </IconButton>
        <IconButton
          disabled={!address}
          size="small"
          component={Link}
          href={address ? getPolygonscanAddressUrl(address) : '#'}
          target="_blank"
        >
          <LinkIcon className={classes.copyIcon} />
        </IconButton>
      </Box>
    </Box>
  )
}
